'use client'
import clsx from 'clsx';
import React, { useState } from 'react';
import { Button } from '@nf/ui';
import { jupiterButton } from 'styled-system/recipes';
import { accountManageStyles } from '../account-manage.style';
import { PageInputWithLabel, PageInputWrapper } from '@/jupiter/components/page-input';
import { SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslations } from 'next-intl';
import { ChangeEmailSchema } from '@/lib/schemas/change-email-schema';
import { useAccountInfo } from '@/hooks/query/account';
import { EmailError, EmailTaken, useChangeEmail } from './hook/use-change-email';
import { Icon } from '@/components/icons/svg-icons';

interface FormInput {
	newEMail: string;
	confNewEMail: string;
  }

export const ChangeEmail = () => {
	const t = useTranslations('General');
	const [isLoading, setIsLoading] = useState(false);
	const { user, refetch } = useAccountInfo() || {};
	const { Email: currentEmail } = user || {};
	const [takenEmail, setTakenEmail] = useState('');
	const {
		register,
		handleSubmit,
		setError,
		reset,
		formState: { errors, isValid  },
	} = useForm<FormInput>({
		mode: 'onBlur',
		resolver: zodResolver(ChangeEmailSchema),
		defaultValues: {
			newEMail: '',
			confNewEMail: '',
		},
	});
	const {
		saveEmail
	} = useChangeEmail();
   
	const onSubmit: SubmitHandler<FormInput> = async ({ newEMail, confNewEMail }) => {
		if (newEMail !== confNewEMail) {
			setError('confNewEMail', { message: 'lbl_EMailNotMatch' });
			return
		}

		if (newEMail === takenEmail) {
			setError('newEMail', { message: 'lbl_RegistMailNotUnique' });
			return
		}

		if (!currentEmail) {
			return
		}
		try {
			setIsLoading(true);
			const isSave = await saveEmail(currentEmail, newEMail);
			if (isSave) {
				reset();
				refetch();
				document.dispatchEvent(new CustomEvent('show-ju-toast-msg', {
					detail: { msg: t('lbl_ChangeEmailSuccess') }
				}));
			}
		} catch (error) {
			if (error instanceof EmailError) {
				// currentEmail error
			} else if (error instanceof EmailTaken) {
				setTakenEmail(newEMail);
				setError('newEMail', { message: 'lbl_RegistMailNotUnique' });
			} else {
				setError('newEMail', { message: 'lbl_RPError02' });
			}
		} finally {
			setIsLoading(false);
		}
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter') {
			handleSubmit(onSubmit)();
		}
	};

	return (
		<main className={accountManageStyles.wrap} onKeyDown={handleKeyDown}>
			<section className={accountManageStyles.section}>
				<div className={accountManageStyles.showInDesktop}>
					<div className={accountManageStyles.customText}>				
						{t('lbl_BelowInfo_ChangeEmailadd')}
					</div>
				</div>
				
				<div className={accountManageStyles.pendingForm}>
					<section className={accountManageStyles.formSection}>
						<div className={accountManageStyles.showInMobile}>
							<div className={accountManageStyles.customText}>				
								{t('lbl_BelowInfo_ChangeEmailadd')}
							</div>
						</div>
						<div className={accountManageStyles.formGroup}>
							<div>

								<PageInputWrapper 
									label={t('lbl_CurrEMail')}
								>
									<div className={accountManageStyles.currentText}>
										{currentEmail}
									</div>
								</PageInputWrapper>
							</div>
							<div className={accountManageStyles.divider}></div>
							<div>
								<PageInputWithLabel
									label={t('lbl_NewEmailTitle')}
									placeholder={t('lbl_NewEmail')}
									errorMessage={errors.newEMail?.message && t(errors.newEMail?.message)}
									{...register('newEMail', { required: true })}
									
								/>
							</div>
							<div>
								<PageInputWithLabel
									label={t('lbl_ConfirmEmail')}
									placeholder={t('lbl_EnterConfirmEmail')}
									errorMessage={errors.confNewEMail?.message && t(errors.confNewEMail?.message)}
									{...register('confNewEMail', { required: true })}
									
								/>
							</div>
						</div>
					</section>
					<div className={accountManageStyles.buttonGroup}>
						<Button 
							className={clsx(jupiterButton({ size: 'lg', visual: !isValid || isLoading?'disable':'primary' }), accountManageStyles.submitButton)}
							onClick={handleSubmit(onSubmit)} 
							disabled={!isValid || isLoading}
						>
							{isLoading?(<Icon className={accountManageStyles.loadingIcon} name="loading" />):t('lbl_SubmitBtn')}
						</Button>
					</div>
		
				</div>
			</section>
		</main>
	)
}